import { render } from "./iconPlus.vue?vue&type=template&id=0d48963a"
import script from "./iconPlus.vue?vue&type=script&lang=js"
export * from "./iconPlus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__